import { useQuery } from '@tanstack/react-query';

import type { DTOSubscriptionPageResponse } from 'src/apis/dto/DTOSubscriptionPage';
import useLogin from 'src/hooks/useLogin';
import { client } from 'src/utils/api';

import { SUBSCRIPTION_QUERY_KEYS } from './useActiveSubscriptions';

export const useSubscriptionPageQuery = () => {
  const { isLogin } = useLogin();

  return useQuery({
    queryKey: SUBSCRIPTION_QUERY_KEYS.page(),
    async queryFn() {
      const response = await client.get<DTOSubscriptionPageResponse>('/api/pages/subscriptions');
      return response.data;
    },
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
    enabled: isLogin,
  });
};
